import React, { Component } from "react";
import AppActions from "../flux/AppActions";
import Toast from "../toast";
import AjaxLoader from "../components/AjaxLoader";
import BrandsList from "../components/BrandsList";

const locale = ( typeof ( window.AppWizardLocale ) !== 'undefined' ? window.AppWizardLocale : false );
if ( !locale ) {
    throw new Error( 'Error: Locale not loaded' );
}

const $ = window.jQuery;
const toast = new Toast();

class PageBrands extends Component {
    constructor(props) {
        super( props );

        this.inputRef = React.createRef();

        this.state = props.app.state;

        this.__getBrands = this.__getBrands.bind( this );
        this.__onBrandClick = this.__onBrandClick.bind( this );
    }

    componentDidMount() {
        //this.__getBrands( this.props );
    }

    __goToHomePage(e) {
        e.preventDefault();
        window.history.back();
        //AppActions.updatePage( 'events' );
    }

    __getBrands(props) {
        window.scrollTo( {
            top: 0
        } );

        this.setState( {
            loading: true
        } );

        let locale = props.locale;
        let { ajaxurl, nonce_name, nonce_value } = locale;
        let self = this;
        let ajaxConfig = {
            url: ajaxurl,
            method: "POST",
            timeout: 29000,
            cache: false,
            async: true,
            data: {
                action: "bth_ajax",
                request: "get_brands",
                campaign: props.app.props.campaign,
                [nonce_name]: nonce_value
            }
        };

        $.ajax( ajaxConfig )
            .done( function (r) {
                if ( r ) {
                    if ( r.success ) {
                        if ( r.data ) {
                            AppActions.updatePage( 'brands' );

                            self.setState( {
                                page_data: r.data.items,
                                loading: false
                            } );
                        }
                        else {
                            toast.show( locale.texts.empty_response, Toast.TYPE_ERROR );
                        }
                    }
                    else {
                        if ( r.data ) {
                            toast.show( r.data, Toast.TYPE_ERROR );
                        }
                        else {
                            toast.show( locale.texts.empty_response, Toast.TYPE_ERROR );
                        }
                    }
                }
                else {
                    toast.show( locale.texts.no_response, Toast.TYPE_ERROR );
                }
            } )
            .fail( function (x, s, e) {
                toast.show( e, Toast.TYPE_ERROR );
            } )
            .always( function () {
                // self.setState( {
                //     loading: false
                // } );
            } );
    }

    __onBrandClick(brandId) {
        let brand = this.state.brands.find(brand => brand.id === brandId);
        AppActions.updateStore( {
            brand: brand,
            page: 'cocktails',
        } );
    }

    render() {
        const locale = this.props.locale;
        //const page_data = ( this.state.page_data.length ? this.state.page_data : false );
        const page_data = ( this.state.brands.length ? this.state.brands : false );

        return (
            <React.Fragment>
                <header className="drink-ideas-header drink-ideas-header--choose-brand d-flex justify-content-center align-items-center">
                    <picture className="drink-ideas-header__bg">
                        <source media="(max-width: 768px)" srcSet={`${locale.img_uri}/afisare-cocktails/savoarea-momentelor-mobile.png`}/>
                        <img src={`${locale.img_uri}/afisare-cocktails/savoarea-momentelor-desktop.jpg`} alt=""/>
                    </picture>
                    {this.state.event ?
                        <div className="drink-ideas-header__text">
                            <h3 className="drink-ideas-header__suggestion-text text-center">
                                ÎȚI RECOMANDĂM BĂUTURILE SPIRTOASE POTRIVITE MOMENTULUI
                            </h3>
                            <h1 className="drink-ideas-header__event-title text-center">
                                {this.state.event.name}
                            </h1>
                        </div> : null}
                </header>

                <section className="choose-brand max-container">
                    {this.state.event ?
                        <section className="choose-brand__event-description"
                         dangerouslySetInnerHTML={{__html: this.state.event.description}}
                        /> : null}

                    {this.state.loading && <AjaxLoader/>}

                    {page_data && <BrandsList locale={locale} items={page_data} onItemClick={this.__onBrandClick}/>}

                    <div className="cocktails__pagination text-center mb-5">
                        <p className="cocktails__pagination-text">
                            ÎNAPOI
                        </p>
                        <a onClick={this.__goToHomePage.bind(this)} href="#" className="cocktails__pagination-link">
                            <img src={locale.img_uri + 'afisare-cocktails/back-button.svg'} alt=""/>
                        </a>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default PageBrands;
